import { initializeApp } from 'firebase/app';
import { getFirestore } from '@firebase/firestore';
import { getStorage } from 'firebase/storage';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: "astrodavido-a9979",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: "G-7YTET2JCRC"
};

export const app = initializeApp(firebaseConfig);
const appCheckSiteKey = process.env.REACT_APP_FIREBASE_APPCHECK_SITE_KEY;
const shouldEnableAppCheck = process.env.NODE_ENV === 'production';

let appCheckInitialized = false;

export const ensureAppCheck = () => {
  if (!appCheckSiteKey || !shouldEnableAppCheck || appCheckInitialized) {
    return;
  }

  appCheckInitialized = true;

  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(appCheckSiteKey),
    isTokenAutoRefreshEnabled: true
  });
};

export const db = getFirestore(app);

export const storage = getStorage(app);
